/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitOverflowOptionSelection} from '../api'

export const useMutationSubmitOverflowOptionSelection = createReactQueryMutationHook('submitOverflowOptionSelection', submitOverflowOptionSelection)
